var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            eager: "",
            persistent: "",
            "max-width": "600",
            transition: "scroll-y-transition",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "white--text orange darken-3",
                  attrs: { flat: "" },
                },
                [
                  _c("v-toolbar-title", [_vm._v("Sblocca asta")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c(
                  "div",
                  { staticClass: "pa-4" },
                  [
                    _c("div", { staticClass: "text-left" }, [
                      _vm._v("\n            Stai usando la versione "),
                      _c("b", [_vm._v("free")]),
                      _vm._v(" di Asta Live:\n            "),
                      _c("br"),
                      _vm._v(
                        "\n            Puoi assegnare/mettere all'asta fino a\n            "
                      ),
                      _c("b", [
                        _vm._v(_vm._s(_vm.Constants.NUM_ASSEGNAZIONI_FREE)),
                      ]),
                      _vm._v(" calciatori.\n            "),
                      _c("br"),
                      _vm._v(
                        "\n            Hai ancora a disposizione\n            "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.asta_info.counter))]),
                      _vm._v(" assegnazioni.\n            "),
                      _c("br"),
                      _vm._v(
                        '\n            Clicca subito su "Vai all\'acquisto" per rimuovere tale limite\n            '
                      ),
                      _c("strong", [_vm._v("in questa asta")]),
                      _vm._v(".\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-center my-4" },
                      [
                        !_vm.premium
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "orange white--text",
                                attrs: { rounded: "", large: "" },
                                on: { click: _vm.gotoPagamento },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-2" }, [
                                  _vm._v("verified"),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                VAI ALL'ACQUISTO\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "orange--text text--lighten-3",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.asta_info.lega.maxSquadre) +
                                          " squadre"
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("v-icon", { staticClass: "ml-2" }, [
                                  _vm._v("verified"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-left" }, [
                      _vm._v("\n            * Asta Live viene\n            "),
                      _c("strong", { staticClass: "error--text" }, [
                        _vm._v("pagata da una sola persona"),
                      ]),
                      _vm._v("\n            e "),
                      _c("strong", { staticClass: "error--text" }, [
                        _vm._v("si sblocca per tutti"),
                      ]),
                      _vm._v(
                        " i\n            componenti dell'asta!\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-center mt-2 font-hemi-head" },
                      [_vm._v("TABELLA PREZZI")]
                    ),
                    _vm._v(" "),
                    _c("tabella-prezzi", {
                      attrs: { maxSquadre: _vm.asta_info.lega.maxSquadre },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right mt-5 mr-2" },
                      [
                        !_vm.premium
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  depressed: "",
                                  rounded: "",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.voucherDialog = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Hai un voucher?\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.voucherDialog,
            callback: function ($$v) {
              _vm.voucherDialog = $$v
            },
            expression: "voucherDialog",
          },
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(" Hai un Voucher? ")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Inseriscilo qui*",
                          required: "",
                          "error-messages": _vm.voucherInputErrors,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.voucherInput.$touch()
                          },
                        },
                        model: {
                          value: _vm.voucherInput,
                          callback: function ($$v) {
                            _vm.voucherInput = $$v
                          },
                          expression: "voucherInput",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pb-5 pr-4" },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey",
                            text: "",
                            rounded: "",
                            large: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.voucherDialog = false
                            },
                          },
                        },
                        [_vm._v("\n            Annulla\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            large: "",
                            disabled: this.$v.$invalid,
                          },
                          on: { click: _vm.submitVoucher },
                        },
                        [_vm._v("\n            Invia\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }